import { SuspensePage } from '@/shared/ui/layout/SuspensePage';
import { PagesStaffEditMain } from './modules/ui/Main';

const StaffEditPage = (
  <SuspensePage>
    <PagesStaffEditMain />
  </SuspensePage>
);

export default StaffEditPage;
